import { HandDrawnOutlineArrow } from '@monofront/design-system/visuals/Icons/HandDrawnOutlineArrow';
import { useTranslations } from 'next-intl';

export const CarouselEndCard = ({ title }) => {
  const tCatalog = useTranslations('Catalog');

  return (
    <article
      aria-label={`${tCatalog('seeAllProducts')} ${title}`}
      data-testname="product-card"
      className={`tw-mx-auto tw-box-border tw-flex tw-h-full
    tw-w-[172px]  tw-items-center
    tw-justify-center tw-rounded-lg tw-border
    tw-border-solid tw-border-blue-200 tw-bg-white tw-p-2
    tw-font-body desktop:tw-w-[210px] desktop:tw-p-4`}
    >
      <div className="tw-flex tw-max-w-36 tw-flex-col tw-items-center">
        <div className="tw-mb-4 tw-size-10 tw-text-blue-600" aria-hidden>
          <HandDrawnOutlineArrow />
        </div>
        <p className={`tw-lf-body-bold-md  tw-text-center`}>
          {tCatalog('seeAllProducts')}
          <br />
          {title}
        </p>
      </div>
    </article>
  );
};
